import { uploadImagesApi, deleteUploadsApi } from "api/upload";

// 기존 Firestore Storage 사용을 커스텀 서버의 /api/post/upload/* 로 이관.
// 기존 함수 시그니처 유지.

/// ✅ mapData 각 항목의 docId 폴더에서 이미지 URL 목록을 붙여 반환.
// 현재 커뮤니티 GET 엔드포인트가 이미 imageUrls 필드를 포함하므로 이 함수의 필요성은 줄었으나,
// 하위 호환을 위해 no-op 에 가까운 동작을 유지한다.
export const insertImageIntoMap = async (mapData) => {
  if (!Array.isArray(mapData)) return mapData;
  return mapData.map((doc) => ({
    imageUrls: Array.isArray(doc.imageUrls) ? doc.imageUrls : [],
    ...doc,
  }));
};

/// ✅ docId 경로에 이미지 업로드 후 URL 목록 반환 (community)
export const uploadCommunityImages = async (docId, imageFiles) => {
  if (!imageFiles || imageFiles.length === 0) return [];
  // 이미 string(url)인 항목은 서버 업로드 없이 통과.
  const files = imageFiles.filter((f) => f instanceof File || f instanceof Blob);
  const kept = imageFiles.filter((f) => typeof f === "string");
  const uploaded = files.length > 0
    ? await uploadImagesApi("community", docId, files)
    : [];
  return [...kept, ...uploaded];
};

/// ✅ docId 경로에 이미지 업로드 후 URL 목록 반환 (match)
export const uploadMatchingImages = async (docId, imageFiles) => {
  if (!imageFiles || imageFiles.length === 0) return [];
  const files = imageFiles.filter((f) => f instanceof File || f instanceof Blob);
  const kept = imageFiles.filter((f) => typeof f === "string");
  const uploaded = files.length > 0
    ? await uploadImagesApi("match", docId, files)
    : [];
  return [...kept, ...uploaded];
};

/// ✅ 업로드된 이미지 삭제
export const deleteImages = async (urls) => {
  if (!urls || urls.length === 0) return;
  try {
    await deleteUploadsApi(urls);
  } catch (e) {
    console.error("deleteImages failed:", e);
  }
};
